(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  // --- Section : Gallery
  if (typeof Gallery !== 'function') {
    class Gallery extends HTMLElement {
      constructor(){
        super();

        this.GallerySwiper = null;
        this.modal = this.nextElementSibling;
        this.init();
      }

      init() {
        const self = this;
        let itemsButton = this.querySelectorAll('.flex-caption.fullscreen');

        if(itemsButton) {
          itemsButton.forEach((button) => {
            button.addEventListener('click', (e) => {
              if(self.GallerySwiper == null){
                self.createSwiper(parseInt(button.closest('.swiper-slide').dataset.index));
              }
            });
          })
        }
      }

      createSwiper(slideToIndex) {
        const modalContent = this.modal.querySelector('.gallery-media-modal__content');
        modalContent.innerHTML = "";
        modalContent.appendChild(this.querySelector('.swiper-gallery-container').cloneNode(true));
        modalContent.querySelector('.swiper').dataset.shown = 1;
        modalContent.querySelectorAll('.image-container').forEach((image) => {
          image.setAttribute('class', 'image-container')
          image.querySelector('img') && image.querySelector('img').setAttribute('sizes', '100vw')
        });

        this.GallerySwiper = modalContent.querySelector('.swiper').swiper;
        modalContent.querySelector('.swiper').swiper.slideTo(slideToIndex)
      }
    }
    customElements.define('gallery-fullsize', Gallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-line"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-header-section');
      this.announce_bar = document.querySelector('#shopify-section-announce-bar');
      this.menu_section = document.querySelector('.menu-section');
      this.headerBounds = {};

      this.getStickyType();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    getStickyType () {
      this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780 ? this.getAttribute('data-sticky-type') === 'sticky' : this.getAttribute('data-sticky-type-mob') === 'sticky';
    }

    setHeaderHeight() {
      this.height =  this.header.offsetHeight + (this.header.classList.contains('header__overlay') ? this.menu_section.offsetHeight : 0)

      document.documentElement.style.setProperty('--header-height', `${this.height}px`)

      if(this.announce_bar){
        document.documentElement.style.setProperty('--announce-bar-height', `${this.announce_bar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-lines"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('#shopify-header-section');
    this.announce_bar = document.querySelector('#shopify-section-announce-bar');
    this.menu_section = document.querySelector('.menu-section');
    this.headerBounds = {};

    this.getStickyType();
    this.setHeaderHeight();

    window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  getStickyType () {
    this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780 ? this.getAttribute('data-sticky-type') === 'sticky' : this.getAttribute('data-sticky-type-mob') === 'sticky';
  }

  setHeaderHeight() {
    this.height =  this.header.offsetHeight + (this.header.classList.contains('header__overlay') ? this.menu_section.offsetHeight : 0)

    document.documentElement.style.setProperty('--header-height', `${this.height}px`)

    if(this.announce_bar){
      document.documentElement.style.setProperty('--announce-bar-height', `${this.announce_bar.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sidebar"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('#shopify-header-section');
    this.announce_bar = document.querySelector('#shopify-section-announce-bar');
    this.menu_section = document.querySelector('.menu-section');
    this.headerBounds = {};

    this.getStickyType();
    this.setHeaderHeight();

    window.matchMedia('(max-width: 780px)').addEventListener('change', this.getStickyType.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  getStickyType () {
    this.headerIsAlwaysSticky = document.documentElement.clientWidth > 780 ? this.getAttribute('data-sticky-type') === 'sticky' : this.getAttribute('data-sticky-type-mob') === 'sticky';
  }

  setHeaderHeight() {
    this.height =  this.header.offsetHeight + (this.header.classList.contains('header__overlay') ? this.menu_section.offsetHeight : 0)

    document.documentElement.style.setProperty('--header-height', `${this.height}px`)

    if(this.announce_bar){
      document.documentElement.style.setProperty('--announce-bar-height', `${this.announce_bar.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  if (typeof Summary !== 'function'){
    class Summary extends HTMLElement {
      constructor(){
        super();
      }

      connectedCallback() {
        const h = this.dataset.hn,
              content = this.closest('article').querySelector('.article-content'),
              summary = this.querySelector('.summary'); 
        let nb_titles = 0;

        for(i = 2; i <= h; i++){
          const titles = content.querySelectorAll("h" + i);
          nb_titles += titles.length;
        }

        if (nb_titles >= this.dataset.limit) {
          var ul = document.createElement('ul');

          if(summary.nodeName == "LINK-COLLAPSING"){
            ul.classList.add("link_collapsing_content");
            ul.style.display = "none";
          }

          ul.innerHtml = "";
          summary.appendChild(ul);
          var toc = "";
          var start = 4;
          var children = content.children;

          for (var i = 0; i < children.length; i++) {
            if(children[i].nodeName.match(/^H\d+$/)){
              var level = children[i].nodeName.substr(1);
              if(level <= h){
                var headerText = (children[i].textContent);
                var anchor = "toc-" + i;

                var tag = '<a href="#' + anchor + '" id="' + anchor + '">' + headerText + '</a>';

                children[i].innerHTML = tag;

                if(headerText){
                    if (level > start) {
                      toc += (new Array(level - start + 1)).join('<ul>');
                    } else if (level < start) {
                      toc += (new Array(start - level + 1)).join('</li></ul>');
                    } else {
                      toc += (new Array(start+ 1)).join('</li>');
                    }
                    start = parseInt(level);
                    toc += '<li><a href="#' + anchor + '">' + headerText + '</a>';
                }
              }
            }
          }

          if (start) {
            toc += (new Array(start + 1)).join('</ul>');
          }

          ul.innerHTML += toc;
          summary.querySelector(".link_collapsing_title").style.opacity = "";
          summary.classList.remove('loading-gradient');
        } else {
          summary.classList.add('hide');
          return;
        }

        ul.querySelectorAll("a[href*='#']:not([href='#'])").forEach((link) => {
          link.addEventListener("click", function(event) {
            event.preventDefault();
            if (
              location.hostname == this.hostname &&
              this.pathname.replace(/^\//, "") == location.pathname.replace(/^\//, "")
            ) {
              var anchor = this.hash;
              anchor = anchor.length ? anchor : content.querySelector("[name=" + this.hash.slice(1) + "]");
              if (anchor) {
                var targetElement = document.querySelector(anchor);
                var rect = targetElement.getBoundingClientRect();
                var offsetTop = rect.top + window.pageYOffset - parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
                window.scrollTo({ top: offsetTop, behavior: "smooth" });
              }
            }
          });
        });
      }
    }
    customElements.define('article-summary', Summary)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-order-tracker"]) return;
  try {
    
  (() => {
    class FaOrderTracker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const form = this.querySelector('[data-tracking-form]');
        const input = this.querySelector('input[name="tracking_number"]');
        const error = this.querySelector('[data-tracking-error]');

        if (!form || !input || !error) return;

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const trackingNumber = input.value.replace(/\s+/g, '').trim();

          if (trackingNumber.length < 5) {
            error.hidden = false;
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
          }

          error.hidden = true;
          input.removeAttribute('aria-invalid');

          const baseUrl = this.dataset.trackingUrl || 'https://t.17track.net/fr#nums=';
          const destination = baseUrl.includes('{code}')
            ? baseUrl.replace('{code}', encodeURIComponent(trackingNumber))
            : `${baseUrl}${encodeURIComponent(trackingNumber)}`;

          window.open(destination, '_blank', 'noopener,noreferrer');
        });

        input.addEventListener('input', () => {
          if (input.value.trim().length >= 5) {
            error.hidden = true;
            input.removeAttribute('aria-invalid');
          }
        });
      }
    }

    class FaOrderEstimator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.processingDays = Number.parseInt(this.dataset.processingDays, 10) || 2;
        this.minDays = Number.parseInt(this.dataset.minDays, 10) || 7;
        this.maxDays = Number.parseInt(this.dataset.maxDays, 10) || 15;

        const form = this.querySelector('[data-estimate-form]');
        this.dateInput = this.querySelector('input[name="order_date"]');
        this.error = this.querySelector('[data-estimate-error]');
        this.result = this.querySelector('[data-estimate-result]');
        this.statusTitle = this.querySelector('[data-status-title]');
        this.statusCopy = this.querySelector('[data-status-copy]');
        this.statusPill = this.querySelector('[data-status-pill]');
        this.firstDate = this.querySelector('[data-first-date]');
        this.lastDate = this.querySelector('[data-last-date]');
        this.steps = Array.from(this.querySelectorAll('[data-step]'));

        if (!form || !this.dateInput || !this.result) return;

        const today = this.startOfDay(new Date());
        this.dateInput.max = this.toInputValue(today);

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.showEstimate();
        });

        this.dateInput.addEventListener('change', () => {
          this.error.hidden = true;
          this.dateInput.removeAttribute('aria-invalid');
        });
      }

      showEstimate() {
        const orderDate = this.parseInputDate(this.dateInput.value);
        const today = this.startOfDay(new Date());

        if (!orderDate) {
          this.showError('Indique la date de ta commande pour afficher une estimation.');
          return;
        }

        if (orderDate > today) {
          this.showError('La date de commande ne peut pas être dans le futur.');
          return;
        }

        if (this.minDays > this.maxDays) {
          this.showError('Les délais configurés dans le thème sont incohérents.');
          return;
        }

        this.error.hidden = true;
        this.dateInput.removeAttribute('aria-invalid');

        const elapsedDays = Math.floor((today.getTime() - orderDate.getTime()) / 86400000);
        const earliestDate = this.addDays(orderDate, this.minDays);
        const latestDate = this.addDays(orderDate, this.maxDays);

        let state;
        let activeStep;

        if (elapsedDays <= this.processingDays) {
          state = 'preparation';
          activeStep = 2;
          this.statusTitle.textContent = 'Commande en préparation';
          this.statusCopy.textContent = 'Ta commande se situe encore dans le délai habituel de préparation. Le lien transporteur sera envoyé dès que le numéro de suivi sera disponible.';
          this.statusPill.textContent = 'Préparation';
        } else if (elapsedDays <= this.maxDays) {
          state = 'transit';
          activeStep = 3;
          this.statusTitle.textContent = 'Commande probablement en route';
          this.statusCopy.textContent = 'D’après la date indiquée, la commande devrait être en cours d’acheminement. Utilise le numéro reçu par e-mail pour consulter les scans réels du transporteur.';
          this.statusPill.textContent = 'En cours';
        } else {
          state = 'late';
          activeStep = 4;
          this.statusTitle.textContent = 'Délai habituel dépassé';
          this.statusCopy.textContent = 'La fenêtre de livraison habituelle est dépassée. Consulte le suivi transporteur puis contacte-nous si aucune mise à jour utile n’apparaît.';
          this.statusPill.textContent = 'À vérifier';
        }

        this.result.dataset.state = state;
        this.result.hidden = false;
        this.firstDate.textContent = this.formatDate(earliestDate);
        this.lastDate.textContent = this.formatDate(latestDate);

        this.steps.forEach((step, index) => {
          const stepNumber = index + 1;
          step.classList.toggle('is-complete', stepNumber < activeStep);
          step.classList.toggle('is-active', stepNumber === activeStep);

          if (stepNumber === activeStep) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });

        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
        this.result.hidden = true;
        this.dateInput.setAttribute('aria-invalid', 'true');
        this.dateInput.focus();
      }

      parseInputDate(value) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
        const [year, month, day] = value.split('-').map(Number);
        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day
        ) {
          return null;
        }

        return this.startOfDay(date);
      }

      startOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
      }

      addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      toInputValue(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      formatDate(date) {
        return new Intl.DateTimeFormat('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(date);
      }
    }

    if (!customElements.get('fa-order-tracker')) {
      customElements.define('fa-order-tracker', FaOrderTracker);
    }

    if (!customElements.get('fa-order-estimator')) {
      customElements.define('fa-order-estimator', FaOrderEstimator);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  /* --- Section Search */
  class SearchForm extends HTMLElement {
    constructor(){
      super();
    }

    connectedCallback(){
      var self = this;

      this.querySelector('form').addEventListener('submit', function(e){
        e.preventDefault();
        e.stopPropagation();
      });

      this.querySelector('input').addEventListener('input',
      theme.utils.throttle(function(){
        setTimeout(function(){
          self.getSearch()
        }, 300)
      },300));
    }

    getSearch(){
      const pagination = this.closest('section').querySelector('.collection_pagination');
      const resultsText = this.closest('section').querySelector('.search_results');
      const resultsGrid = this.closest('section').querySelector('#productsGrid');
      const resultsContent = this.closest('section').querySelector('#productsGrid');

      resultsGrid.classList.add('loading');
      resultsContent.innerHTML = '';

      let form = this.querySelector('form');
      const formSerialize = JSON.parse(theme.utils.serializeForm(form));

      fetch(form.getAttribute('action') + '?q='+ formSerialize.q + '&options%5Bprefix%5D=last',
        { ...theme.utils.fetchConfig('javascript') })
        .then(response => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const Source_pagination = html.querySelector('.collection_pagination');
          const Source_resultsText = html.querySelector('.search_results');
          const Source_resultsContent = html.querySelector('#productsGrid');

          if (Source_pagination && pagination) pagination.innerHTML = Source_pagination.innerHTML;
          if (Source_resultsText && resultsText) resultsText.innerHTML = Source_resultsText.innerHTML;
          if (Source_resultsContent && resultsContent) resultsContent.innerHTML = Source_resultsContent.innerHTML;

          resultsGrid.querySelectorAll('img', 'svg').forEach((lazyBackground) => {
            theme.utils.lazyBackgroundObserver.observe(lazyBackground);
          });

          resultsGrid.classList.remove('loading');
          resultsGrid.classList.remove('hide');
        })
    }
  }
  customElements.define('search-form', SearchForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"] && !Shopify.designMode) return;
  try {
    
  if(typeof Map !== "function"){
    // --- Section : Map
    class Map extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        this.settings = {
          apiKey: this.getAttribute('data-api-key'),
          address: this.getAttribute('data-address'),
          mapStyle: this.getAttribute('data-map-style'),
          enablePin: this.getAttribute('data-enable-pin') == "true" ? true : false,
          markerColor: this.getAttribute('data-marker-color')
        };

        this.map;

        this.init();
      }

      init(){
        const self = this;
        this.map = null;
        if (typeof this.settings.apiKey !== 'string' || this.settings.apiKey === '') {
          return;
        }

        if (typeof window.google === 'undefined') {
          theme.utils.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.settings.apiKey
          ).then(function(){
            self.createMap();
          });
        } else {
          self.createMap();
        }
      }

      createMap() {
        const self = this;
        new Promise(function(resolve, reject) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: self.settings.address }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              reject(status);
            } else {
              resolve(results);
            }
          });
        }).then(function(results){
          var style = JSON.parse(self.settings.mapStyle);

          var config = {
            zoom: 14,
            styles: style
          };

          var mapOptions = {
            zoom: config.zoom,
            styles: config.styles,
            center: results[0].geometry.location,
            draggable: true,
            clickableIcons: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            disableDefaultUI: false
          }; 

          self.map = new google.maps.Map(this, mapOptions);
          var enablePin = self.settings.enablePin;
          var markerColor = self.settings.markerColor;
          var center = self.map.getCenter();

          var markerIcon = {
            path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
            fillColor: markerColor,
            fillOpacity: 0.9,
            scale: 1.5,
            strokeWeight: 0
          };

          //eslint-disable-next-line no-unused-vars
          if(enablePin){
            new google.maps.Marker({
              map : self.map,
              icon: markerIcon,
              position: center
            });
          }

          google.maps.event.addDomListener(window, 'resize',
            theme.utils.debounce(250,function() {
              google.maps.event.trigger(self.map, 'resize');
              self.map.setCenter(center);
            })
          );
        }).catch(function(status){
          var errorMessage;
          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break; 
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var mapContainer = self.closest('.map-section');
            mapContainer.classList.add('map-section--load-error');
            mapContainer.querySelector('.map-error__wrapper').innerHTML = '<div class="errors text-center" style="width: 100%;">' +  errorMessage + '</div>';
          }
        });
      }

      onUnload(){
        if (typeof window.google !== 'undefined' && this.map != null) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    }
    customElements.define('map-js', Map);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-orders-notif"] && !Shopify.designMode) return;
  try {
    
  if(typeof OrdersNotif !== 'function'){
    // snippet: popup-orders-notif
    class OrdersNotif extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        var self = this;
        this.test = this.getAttribute('data-test') == "true" ? true : false;
        this.delay = this.test ? 0 : parseInt(this.getAttribute('data-delay'));

        this.x = setInterval(function() {
          var randomNotificationNumber = Math.floor((Math.random() * 29) + 1),
            randomProductNumber = Math.floor((Math.random() * 8) + 1),
            citiesArray = Shopify.theme_settings.popup_orders_notifs_city,
            randomIndexCity = Math.floor(Math.random() * citiesArray.length),
            randomCity = citiesArray[randomIndexCity];

            let product = self.querySelector('.popup-orders-notif-content:nth-child('+randomProductNumber+')');
            if(self.querySelector('.popup-orders-notif-content:not(.hide)')) {
              self.querySelector('.popup-orders-notif-content:not(.hide)').classList.add('hide');
            }

            self.classList.remove('fadeOut'),
            product.classList.remove('hide'),
            product.querySelector('.popup-orders-notif__random-city').innerText = randomCity,
            product.querySelector('.popup-orders-notif__time').innerText = randomNotificationNumber;

            if(!self.test){
              setTimeout(function() {
                self.classList.add('fadeOut');
              }, 4000);
            } else {
              clearInterval(self.x);
            }
        }, self.delay * 1e3);

        this.querySelectorAll('.popup-orders-notif-content').forEach( (product) => {
          product.addEventListener('click', function(){
            window.location.href= this.getAttribute('data-href');
          })
        });

        this.querySelector('.modal__close').addEventListener('click', function(){
          self.close();
        });
      }

      close(){
        if(this.x) clearInterval(this.x);
        this.container.classList.add('hide');
      }
    }
    customElements.define('popup-orders', OrdersNotif);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-rgpd-cookies"] && !Shopify.designMode) return;
  try {
    
  // -- Popup RGPD
  if(typeof RGPD !== 'function'){
    class RGPD extends HTMLElement {
      constructor(){
        super()
      }

      connectedCallback(){
        this.rgpd_banner_container = this.querySelector('modal-dialog');
        this.rgpd_banner = this.rgpd_banner_container.querySelector('.rgpd-cookiebanner');
        this.rgpd_consent_stored_once = !1;
        this.rgpd_categories = ["functional", "preferences", "statistics", "marketing"];
        this.rgpd_user_data = [];
        this.rgpdData = {
          test_mode: this.dataset.test,
          dismiss_on_scroll: 0,
          set_cookies: [],
          cookie_expiry: 365
        };
    
        var self = this;
    
        document.addEventListener('consentCustomer', () => {
          self._conditionally_show_banner();
    
          if (typeof Storage !== "undefined" && sessionStorage.rgpd_user_data) {
            self.rgpd_user_data = JSON.parse(sessionStorage.rgpd_user_data)
          }
      
          var rgpd_id_cookie = theme.Cookies.get("id");
          var rgpd_id_session = "";
          var rgpd_id = "";
          if (typeof Storage !== "undefined" && sessionStorage.rgpd_id) {
            rgpd_id_session = JSON.parse(sessionStorage.rgpd_id)
          }
      
          if (rgpd_id_cookie.length == 0 && rgpd_id_session.length > 0) {
            rgpd_id = rgpd_id_session;
            theme.Cookies.set("rgpd_id", rgpd_id, self.rgpdData.cookie_expiry);
          }
          if (rgpd_id_cookie.length > 0 && rgpd_id_session.length == 0) {
            rgpd_id = rgpd_id_cookie
          }
          if (typeof Storage !== "undefined") {
            sessionStorage.rgpd_id = JSON.stringify(rgpd_id)
          }
        });      
      }

      _rgpd_create_element(el, content) {
        let obj = document.createElement(el);
        obj.innerHtml = content;
        return obj
      }

      _rgpd_add_event(event, selector, callback) {
        document.addEventListener(event, e => {
          if (e.target.closest(selector)) {
            callback(e)
          }
        });
      }

      _rgpd_is_hidden(el) {
        return el.offsetParent === null
      }
      
      _rgpd_html_decode(input) {
        var doc = (new DOMParser).parseFromString(input, "text/html");
        return doc.documentElement.textContent
      }

      _rgpd_set_category_as_body_class() {
        let classList = document.body.className.split(/\s+/);
        for (let i = 0; i < classList.length; i++) {
          if (classList[i].indexOf("rgpd-") !== -1 && classList[i] !== "rgpd-document") {
            document.body.classList.remove(classList[i])
          }
        }
        let cats = this._rgpd_accepted_categories();
        for (let i in cats) {
          if (cats.hasOwnProperty(i)) {
            document.body.classList.add("rgpd-" + cats[i])
          }
        }
        let services = this._rgpd_get_all_service_consents();
        for (let service in services) {
          if (services.hasOwnProperty(service) && services[service]) {
            document.body.classList.add("rgpd-" + service)
          }
        }
      }

      _rgpd_enable_category(category, service) {
        service = typeof service !== "undefined" ? service : "do_not_match";
        if (category === "")
          category = "do_not_match";
        if (category === "functional") {
          return
        }
        if (category === "marketing") {
          this._rgpd_set_integrations_cookies()
        }
        document.querySelectorAll(".rgpd-blocked-content-notice.rgpd-accept-" + category + ", .rgpd-blocked-content-notice[data-service=" + service + "]").forEach(obj => {
          obj.parentNode.removeChild(obj)
        });
      
        document.querySelectorAll("[data-category=" + category + "], [data-service=" + service + "]").forEach(obj => {
          let elementService = obj.getAttribute("data-service");
          if (rgpd_is_service_denied(elementService)) {
            return
          }
          if (obj.getAttribute("data-category") === "functional") {
            return
          }
          obj.classList.add("rgpd-activated")
        });
      }
      
      _rgpd_array_is_empty(arr) {
        for (let key in arr) {
          if (arr.hasOwnProperty(key)) {
            return !1
          }
        }
        return !0
      }
      
      _rgpd_get_services_on_page() {
        let services = [];
        document.querySelectorAll("[data-service]").forEach(obj => {
          let service = obj.getAttribute("data-service");
          if (services.indexOf(service) == -1) {
            services.push(service)
          }
        });
        return services
      }
      
      _rgpd_is_bot() {
        var botPattern = "(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var reBot = new RegExp(botPattern, "i");
        var userAgent = navigator.userAgent;
        if (reBot.test(userAgent)) {
          return !0
        } else {
          return !1
        }
      }
      
      _rgpd_is_speedbot() {
        var userAgent = navigator.userAgent;
        var speedBotPattern = "(GTmetrix|pingdom|pingbot|Lighthouse)";
        var speedBot = new RegExp(speedBotPattern, "i");
        if (speedBot.test(userAgent)) {
          return !0
        } else {
          return !1
        }
      }
      
      _rgpd_exists_service_consent() {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json);
          for (const key in consented_services) {
            if (consented_services.hasOwnProperty(key)) {
              if (consented_services[key] == !0) {
                return !0
              }
            }
          }
        } catch (e) {
          return !1
        }
        return !1
      }
      
      _rgpd_set_service_consent(service, consented) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }
        consented_services[service] = consented;
        theme.Cookies.set("rgpd_consented_services", JSON.stringify(consented_services), this.rgpdData.cookie_expiry);
      }
      
      _rgpd_clear_all_service_consents() {
        theme.Cookies.set("rgpd_consented_services", "", this.rgpdData.cookie_expiry);
      }
      
      _rgpd_get_all_service_consents() {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services;
        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }
        return consented_services
      }
      
      _rgpd_track_status_end() {
        if (!this.rgpd_consent_stored_once) {
          rgpd_track_status()
        }
      }

      _rgpd_track_status(status) {
        var cats = [];
        status = typeof status !== "undefined" ? status : !1;
        if (!status) {
          cats = this._rgpd_accepted_categories()
        } else {
          cats = [status]
        }
        this._rgpd_set_category_as_body_class();
        var saved_cats, saved_services;
        try {
          saved_cats = JSON.parse(theme.Cookies.get("saved_categories"))
        } catch (e) {
          saved_cats = {}
        }
        try {
          saved_services = JSON.parse(theme.Cookies.get("saved_services"))
        } catch (e) {
          saved_services = {}
        }
        var consented_services = this._rgpd_get_all_service_consents();
        if (this._rgpd_equals(saved_cats, cats) && this._rgpd_equals(saved_services, consented_services)) {
          return
        }

        theme.Cookies.set("rgpd_saved_categories", JSON.stringify(cats), this.rgpdData.cookie_expiry);
        theme.Cookies.set("rgpd_saved_services", JSON.stringify(consented_services), this.rgpdData.cookie_expiry);
        this.rgpd_consent_stored_once = !0;
      }
      
      _rgpd_accepted_categories() {
        var self = this;
        var consentedCategories = this.rgpd_categories;
        var consentedTemp = [];
        for (var key in consentedCategories) {
          if (consentedCategories.hasOwnProperty(key)) {
            var category = consentedCategories[key];
            if (this._rgpd_has_consent(category)) consentedTemp.push(category)
          }
        }
        consentedCategories = consentedCategories.filter(function (value, index, consentedCategories) {
          return self._rgpd_in_array(value, consentedTemp)
        });
        return consentedCategories
      }
      
      _rgpd_sync_category_checkboxes() {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) {
            var category = this.rgpd_categories[key];
            if (this._rgpd_has_consent(category) || category === "functional") {
              document.querySelectorAll("input.rgpd-" + category).forEach(obj => {
                obj.checked = !0
              })
            } else {
              document.querySelectorAll("input.rgpd-" + category).forEach(obj => {
                obj.checked = !1
              })
            }
          }
        }
      }
      
      _rgpd_merge_object(userdata, ajax_data) {
        var output = [];
        for (key in ajax_data) {
          if (ajax_data.hasOwnProperty(key))
            output[key] = ajax_data[key]
        }
        for (var key in userdata) {
          if (!ajax_data.hasOwnProperty(key) || typeof ajax_data[key] === "undefined") {
            if (userdata.hasOwnProperty(key))
              output[key] = userdata[key]
          }
        }
        return output
      }
      
      _rgpd_clear_all_rgpdData_cookies(cookie_part) {
        var foundCookie = !1;
        if (typeof document === "undefined") return foundCookie;

        var secure = ";secure";
        var date = new Date;
        date.setTime(date.getTime() - 24 * 60 * 60 * 1e3);
        var expires = ";expires=" + date.toGMTString();
        if (window.location.protocol !== "https:")
          secure = "";
        (function () {
          var cookies = document.cookie.split("; ");
          for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            var skip_last = d.length > 1;
            while (d.length > 0) {
              var cookieName = cookies[c].split(";")[0].split("=")[0];
              var p = location.pathname;
              p = p.replace(/^\/|\/$/g, "").split("/");
              if (cookieName.indexOf(cookie_part) !== -1) {
                foundCookie = !0;
                var cookieBase = encodeURIComponent(cookieName) + "=;SameSite=Lax" + secure + expires + ";domain=." + d.join(".") + ";path=";
                var cookieBaseDomain = encodeURIComponent(cookieName) + "=;SameSite=Lax" + secure + expires + ";domain=;path=";
                document.cookie = cookieBaseDomain + "/";
                document.cookie = cookieBase + "/";
                while (p.length > 0) {
                  var path = p.join("/");
                  if (path.length > 0) {
                    document.cookie = cookieBase + "/" + path;
                    document.cookie = cookieBaseDomain + "/" + path;
                    document.cookie = cookieBase + "/" + path + "/";
                    document.cookie = cookieBaseDomain + "/" + path + "/"
                  }
                  p.pop()
                }
              }
              d.shift();
              if (skip_last && d.length == 1)
                d.shift()
            }
          }
        })();
        return foundCookie
      }
      
      _rgpd_integrations_init() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key) && cookiesToSet[key][1] === "1")
            theme.Cookies.set("rgpd_" + key, cookiesToSet[key][1], this.rgpdData.cookie_expiry);
        }
      }
      
      _rgpd_integrations_revoke() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key)) {
            theme.Cookies.set("rgpd_" + key, cookiesToSet[key][1], this.rgpdData.cookie_expiry);
            if (cookiesToSet[key][1] == !1) this._rgpd_clear_all_rgpdData_cookies(key)
          }
        }
      }
      
      _rgpd_set_integrations_cookies() {
        var cookiesToSet = this.rgpdData.set_cookies;
        for (var key in cookiesToSet) {
          if (cookiesToSet.hasOwnProperty(key)) theme.Cookies.set("rgpd_" + key, cookiesToSet[key][0], this.rgpdData.cookie_expiry);
        }
      }
      
      _rgpd_wp_set_consent(type, value) {
        if (typeof wp_set_consent == "function") this._wp_set_consent(type, value)
      }
      
      _rgpd_equals(array_1, array_2) {
        if (!Array.isArray(array_1)) {
          array_1 = Object.keys(array_1);
          array_2 = Object.keys(array_2)
        }
        if (!array_1 || !array_2) return !1;
        if (array_1.length != array_2.length) return !1;
        for (var i = 0, l = array_1.length; i < l; i++) {
          if (array_1[i] instanceof Array && array_2[i] instanceof Array) {
            if (!rgpd_equals(array_1[i], array_2[i]))
              return !1
          } else if (array_1[i] != array_2[i])  return !1
        }
        return !0
      }

      _rgpd_in_array (needle, haystack) {
        let length = haystack.length;
        for (let i = 0; i < length; i++) {
          if (haystack[i] == needle) return !0
        }
        return !1
      }

      _rgpd_highest_accepted_category () {
        var consentedCategories = rgpd_accepted_categories();

        if (this._rgpd_in_array("marketing", consentedCategories)) {
          return "marketing" 
        }

        if (this._rgpd_in_array("statistics", consentedCategories)) {
          return "statistics"
        }
        
        if (this._rgpd_in_array("preferences", consentedCategories)) {
          return "preferences"
        }

        return "functional"
      }

      _rgpd_accept_all () {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) {
            this._rgpd_set_consent(this.rgpd_categories[key], "allow")
          }
        }
      }

      _conditionally_show_banner () {
        this._rgpd_set_consent("functional", "allow")
        let rev_cats = this.rgpd_categories.reverse();

        for (let key in rev_cats) {
          if (rev_cats.hasOwnProperty(key)) {
            let category = this.rgpd_categories[key];

            if (this._rgpd_has_consent(category)) {
              this._rgpd_enable_category(category)
            }
          }
        }

        if (this._rgpd_exists_service_consent()) {
          this._rgpd_enable_category("", "general");
          let services = this._rgpd_get_services_on_page();

          for (let key in services) {
            if (services.hasOwnProperty(key)) {
              let service = services[key];
    
              if (service.length == 0)
                continue;
              if (this._rgpd_has_service_consent(service)) {
                document.querySelectorAll(".rgpd-accept-service[data-service=" + service + "]").forEach(obj => {
                  obj.checked = !0
                });

                this._rgpd_enable_category("", service)
              }
            }
          }
        }

        this._rgpd_sync_category_checkboxes();
        this._rgpd_integrations_init();

        if (theme.Cookies.get("saved_categories") === "") {
          this._rgpd_track_status("do_not_track")
        }

        this._rgpd_set_category_as_body_class();
        this._rgpd_create_events();
        this._rgpd_enable_category("functional")
        this._show_cookie_banner()
      }

      _show_cookie_banner () {
        let disableCookiebanner = this._rgpd_is_speedbot();

        if (this.rgpd_banner && !disableCookiebanner) {
          this.rgpd_banner.querySelectorAll(".rgpd-links a:not(.rgpd-external), .rgpd-buttons a:not(.rgpd-external)").forEach(obj => {
            let docElement = obj;
            docElement.classList.add("rgpd-hidden");
          });

          this.rgpd_banner_container.style.display = '';

          if(this.rgpdData.test_mode == "true") {
            this.rgpd_banner_container.setAttribute('open', '');
            this.rgpd_banner.classList.add("rgpd-show");
          } else if(window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
            this._rgpd_set_banner_status();
          }
        }
      }

      _rgpd_set_banner_status (status) {
        let prevStatus = theme.Cookies.get("rgpd_cookie_status");
        status = typeof status !== "undefined" ? status : prevStatus;

        if (status !== prevStatus) {
          theme.Cookies.set("rgpd_cookie_status", status, this.rgpdData.cookie_expiry);
        }

        if (status.length === 0){
          status = "show"
        }

        if (status === "show") {
          this.rgpd_banner_container.setAttribute('open', '');
          prevStatus = "dismissed"
        } else {
          this.rgpd_banner_container.removeAttribute('open');
          prevStatus = "show"
        }

        if(this.rgpd_banner && status.length > 0) {
          this.rgpd_banner.classList.remove("rgpd-" + prevStatus);
          this.rgpd_banner.classList.add("rgpd-" + status);
        }
      }

      _rgpd_has_consent (category) {
        if (this._rgpd_is_bot()) {
          return !0
        }

        if (category === "functional") {
          return !0;
        }

        var has_consent, value;
        value = theme.Cookies.get(category);
        has_consent = value === "allow"

        return has_consent
      }

      _rgpd_is_service_denied (service) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services

        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }

        if (!consented_services.hasOwnProperty(service))
          return !1
        else
          return !consented_services[service]
      }

      _rgpd_has_service_consent (service) {
        var consented_services_json = theme.Cookies.get("consented_services");
        var consented_services

        try {
          consented_services = JSON.parse(consented_services_json)
        } catch (e) {
          consented_services = {}
        }

        if (!consented_services.hasOwnProperty(service))
          return !1
        else
          return consented_services[service]
      }

      _rgpd_set_consent (category, value) {
        var previous_value = theme.Cookies.get(category);
        if (previous_value === value) return;

        var checked = value === "allow";
        document.querySelectorAll("input.rgpd-" + category).forEach(obj => { obj.checked = checked });

        theme.Cookies.set("rgpd_" + category, value, this.rgpdData.cookie_expiry);

        if (value === "allow") {
          this._rgpd_enable_category(category)
        }

        this._rgpd_wp_set_consent(category, value);

        if(value === "allow" && (category == "statistics" || category == "preferences" || category == "marketing")) {
          window.Shopify.customerPrivacy.setTrackingConsent(true, () => {})
        }

        if (category === "statistics") {
          this._rgpd_wp_set_consent("statistics-anonymous", "allow")
        }

        if (category === "marketing" && value === "deny") {
          this._rgpd_integrations_revoke();

          setTimeout(function () {
            location.reload()
          }, 500)
        }
      }

      _rgpd_deny_all () {
        for (var key in this.rgpd_categories) {
          if (this.rgpd_categories.hasOwnProperty(key)) this._rgpd_set_consent(this.rgpd_categories[key], "deny")
        }

        var consentLevel = rgpd_highest_accepted_category();
        var reload = !1;

        if (consentLevel !== "functional" || rgpd_exists_service_consent()) reload = !0
        if (rgpd_clear_all_rgpdData_cookies("rgpd_service")) reload = !0

        rgpd_clear_all_service_consents();
        rgpd_integrations_revoke();
        rgpd_fire_categories_event();
        rgpd_track_status();
      }

      _rgpd_create_events(){
        var self = this;

        document.addEventListener("rgpd_consent_action", function (e) {
          self._rgpd_set_consent(e.detail.category, "allow");
          self._rgpd_track_status()
        });

        this._rgpd_add_event("click", ".rgpd-accept", function (e) {
          e.preventDefault();
          self._rgpd_accept_all();
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_track_status()
        });
        
        this._rgpd_add_event("click", ".rgpd-save-preferences", function (e) {
          let obj = e.target;
          self.rgpd_banner = obj.closest(".rgpd-cookiebanner");
          for (var key in self.rgpd_categories) {
            if (self.rgpd_categories.hasOwnProperty(key)) {
              var category = self.rgpd_categories[key];
              var categoryElement = self.rgpd_banner.querySelector("input.rgpd-" + category);
              if (categoryElement) {
                if (categoryElement.checked)
                  self._rgpd_set_consent(category, "allow")
                else
                  self._rgpd_set_consent(category, "deny")
              }
            }
          }
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_track_status()
        });
        
        this._rgpd_add_event("click", ".rgpd-view-preferences", function (e) {
          let obj = e.target;
          self.rgpd_banner = obj.closest(".rgpd-cookiebanner");
          if (self.rgpd_banner.querySelector(".rgpd-categories").classList.contains("rgpd-fade-in")) {
            self.rgpd_banner.classList.remove("rgpd-categories-visible");
            self.rgpd_banner.querySelector(".rgpd-categories").classList.remove("rgpd-fade-in");
            self.rgpd_banner.querySelector(".rgpd-view-preferences").classList.remove('hide')
            self.rgpd_banner.querySelector(".rgpd-save-preferences").classList.add('hide')
          } else {
            self.rgpd_banner.classList.add("rgpd-categories-visible");
            self.rgpd_banner.querySelector(".rgpd-categories").classList.add("rgpd-fade-in");
            self.rgpd_banner.querySelector(".rgpd-view-preferences").classList.add('hide')
            self.rgpd_banner.querySelector(".rgpd-accept").classList.add('hide')
            self.rgpd_banner.querySelector(".rgpd-save-preferences").classList.remove('hide')
          }
        });
        
        this._rgpd_add_event("change", ".rgpd-manage-consent-container .rgpd-category", function (e) {
          for (var key in self.rgpd_categories) {
            if (self.rgpd_categories.hasOwnProperty(key)) {
              var category = self.rgpd_categories[key];
              var categoryElement = document.querySelector(".rgpd-manage-consent-container input.rgpd-" + category);
              if (categoryElement) {
                if (categoryElement.checked)
                  self._rgpd_set_consent(category, "allow")
                else
                  self._rgpd_set_consent(category, "deny")
                self._rgpd_set_banner_status("dismissed");
                self._rgpd_track_status()
              }
            }
          }
        });
        
        this._rgpd_add_event("click", ".rgpd-deny", function (e) {
          e.preventDefault();
          self._rgpd_set_banner_status("dismissed");
          self._rgpd_deny_all()
        });
        
        this._rgpd_add_event("click", "button.rgpd-manage-settings", function (e) {
          e.preventDefault();
          var catsContainer = document.querySelector(".rgpd-cookiebanner .rgpd-categories");
          var saveSettings = document.querySelector(".rgpd-save-settings");
          var manageSettings = document.querySelector("button.rgpd-manage-settings");
          if (!self._rgpd_is_hidden(catsContainer)) {
            saveSettings.style.display = "none";
            manageSettings.style.display = "block";
            catsContainer.style.display = "none"
          } else {
            saveSettings.style.display = "block";
            manageSettings.style.display = "none";
            catsContainer.style.display = "block"
          }
        });
        
        this._rgpd_add_event("click", "button.rgpd-manage-consent", function (e) {
          e.preventDefault();
          self._rgpd_set_banner_status("show")
        });

        document.addEventListener('shopify:section:load', function(e) {
          if("shopify-section-" + self.rgpd_banner_container.dataset.sectionId == e.target.id) {
            self.rgpdData.test_mode = e.target.querySelector('[data-test]').dataset.test;
            self.rgpd_banner_container = e.target.querySelector('[data-test]');
            self.rgpd_banner = self.rgpd_banner_container.querySelector('.rgpd-cookiebanner');
            self._show_cookie_banner();
          }
        });
      }
    }
    customElements.define('popup-rgpd', RGPD)
  }

  } catch(e) { console.error(e); }
})();
})();
